export function formatCurrency(value = '0', locale = 'en-US', options) {
  var formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'narrowSymbol',
    ...(options || {})
  });

  const strValue =
    locale === 'en-US'
      ? (value?.toString().replace(/[$,]/g, '') ?? '0') // Replace $ and Thousand seperator(,) for EN before converting to floating value
      : (value?.toString().replace(/[$\s]/g, '').replace(/[,]/g, '.') ?? '0'); // Replace $ and Thousand seperator(space \s) for FN before converting to floating value

  return formatter.format(round(strValue));
}

export function formatPercent(value = '', locale = 'en-US', options) {
  var formatter = new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...(options || {})
  });
  return formatter.format(parseFloat(value));
}

// Format $1000 as $1k
export function formatCurrencyThousand(value = '', locale = 'en-US', options) {
  return formatCurrency(value, locale, {
    compactDisplay: 'short',
    notation: 'compact',
    unitDisplay: 'narrow',
    ...(options || {})
  });
}

// Round to two decimal places
export function round(num) {
  return +(Math.round(Number(num ?? 0) * 100) / 100).toFixed(2);
}

export function getFormatCurrencyOptionsForNoDecimal(value) {
  if (typeof value !== 'number' && typeof value !== 'string') {
    return value;
  }
  const hasNoDecimal = parseFloat(value) % 1 === 0;
  return {
    minimumFractionDigits: hasNoDecimal ? 0 : 2,
    maximumFractionDigits: 2
  };
}
